import { render, staticRenderFns } from "./additionalnewservice.vue?vue&type=template&id=56e33fd5&scoped=true&"
import script from "./additionalnewservice.vue?vue&type=script&lang=js&"
export * from "./additionalnewservice.vue?vue&type=script&lang=js&"
import style0 from "./additionalnewservice.vue?vue&type=style&index=0&id=56e33fd5&prod&lang=scss&scoped=true&"
import style1 from "./additionalnewservice.vue?vue&type=style&index=1&id=56e33fd5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e33fd5",
  null
  
)

export default component.exports